export const RATIO_OF_MOLLAR_MASSES = 3.664 // tons of CO2 per ton of carbon
